import React, {Component} from 'react';
import { Field } from 'redux-form';
import {GridRow, GridColumn} from '@react/react-spectrum/Grid';
import Textfield from '@react/react-spectrum/Textfield';
import Textarea from '@react/react-spectrum/Textarea';
import Select from '@react/react-spectrum/Select';
import Link from '@react/react-spectrum/Link';
import FieldLabel from '@react/react-spectrum/FieldLabel';
import Checkbox from '@react/react-spectrum/Checkbox';
import Radio from '@react/react-spectrum/Radio';
import RadioGroup from '@react/react-spectrum/RadioGroup';
import Validator from '../validation';
import { Translate } from 'react-redux-i18n';
import './DataField.css';
import { string } from 'prop-types';

export class Item extends Component { 
    
    render(){
        let dataField = <div></div>;
            switch(this.props.item.type){
                case 'textfield': {
                    const vName = this.props.item.validator;
                    const rawVal = this.props.input.value;
                    const vr =
                      vName && rawVal !== undefined && rawVal !== null && rawVal !== ''
                        ? Validator[vName](rawVal)
                        : 'valid';
                    const showInvalid =
                      rawVal !== undefined &&
                      rawVal !== null &&
                      rawVal !== '' &&
                      vr !== 'valid';
                    const validationState = showInvalid ? 'invalid' : null;
                    const { validator, ...textFieldItem } = this.props.item;
                    let maxLenMessage = null;
                    if (
                      vr === 'invalidMaxLength' &&
                      this.props.i18nForm &&
                      (vName === 'prefixContactField' || vName === 'suffixContactField')
                    ) {
                        const errKey =
                          vName === 'suffixContactField'
                            ? `${this.props.i18nForm}.suffixMaxLengthError`
                            : `${this.props.i18nForm}.prefixMaxLengthError`;
                        maxLenMessage = (
                          <span className="datafield-validator-message" role="alert">
                            <Translate value={errKey} />
                          </span>
                        );
                    }
                    dataField = (
                      <React.Fragment>
                        <Textfield
                          {...textFieldItem}
                          onBlur={this.props.input.onBlur}
                          onFocus={this.props.input.onFocus}
                          onChange={this.props.input.onChange}
                          required={
                            this.props.item.required
                              ? this.props.meta.touched
                                ? this.props.item.required
                                : false
                              : false
                          }
                          validationState={validationState}
                          value={this.props.input.value}
                        />
                        {maxLenMessage}
                      </React.Fragment>
                    );
                    break;
                }
                case 'select':
                    if(this.props.item.multiple)
                    {
                        if(typeof this.props.input.value == "string" && this.props.input.value) {
                            this.props.input.value = this.props.input.value.split(";");
                        }
                        dataField = <Select  
                        disabled={this.props.item.options ? false : true }
                        {...this.props.item} 
                        onChange={this.props.input.onChange} 
                        // onOpen={this.props.input.onFocus}
                        // onClose={this.props.input.onBlur} 
                        value={this.props.input.value }
                        required={this.props.item.required ? this.props.meta.touched ? this.props.item.required : false : false}
                        invalid={this.props.item.validator ? this.props.input.value ? !Validator[this.props.item.validator](this.props.input.value) : null : null}
                        placeholder={this.props.input.value && this.props.input.value.length > 0  ? this.props.input.value.join(', ') : this.props.item.placeholder}/>;
                    }
                    else
                    {
                        dataField = <Select 
                        disabled={this.props.item.options ? false : true }
                        {...this.props.item} 
                        onChange={this.props.input.onChange} 
                        // onOpen={this.props.input.onFocus}
                        // onClose={this.props.input.onBlur}
                        value={this.props.input.value} 
                        required={this.props.item.required ? this.props.meta.touched ? this.props.item.required : false : false}
                        placeholder={this.props.item.placeholder}/>;
                    }
                    
                    break;
                case 'link':
                    dataField = <Link {...this.props.item}>{this.props.item.label}</Link>
                    break;
                case 'checkbox':
                    dataField = <Checkbox  {...this.props.item}
                    checked={this.props.input.value ? true : false} 
                    onChange={this.props.input.onChange}
                    onBlur={this.props.input.onBlur}
                    onFocus={this.props.input.onFocus}
                    />
                    break;
                case 'radio':
                    dataField = <Radio {...this.props.item}
                    checked={this.props.input.value ? true : false} 
                    onChange={this.props.input.onChange}
                    onBlur={this.props.input.onBlur}
                    onFocus={this.props.input.onFocus}
                    />
                    break;
                case 'radiogroup':
                    let radios = []
                    this.props.item.radios.map((obj,idx) =>{
                        radios.push(<Radio {...obj} key={obj.key? obj.key : obj.label+"_"+idx}/>)
                        return null;
                    });
                    dataField = <RadioGroup {...this.props.item}
                    selectedValue = {this.props.input.value}
                    onChange={this.props.input.onChange}
                    onBlur={this.props.input.onBlur}
                    onFocus={this.props.input.onFocus}>
                        {radios}
                    </RadioGroup>
                    break;
                case 'textarea':
                    dataField = <Textarea {...this.props.item} 
                    style={this.props.item.style}
                    onBlur={this.props.input.onBlur}
                    onFocus={this.props.input.onFocus}
                    onChange={this.props.input.onChange} 
                    required={this.props.item.required ? this.props.meta.touched ? this.props.item.required : false : false}
                    validationState={this.props.item.validator ? this.props.input.value ? Validator[this.props.item.validator](this.props.input.value) : null : null }
                    value={this.props.input.value}/>;
                    break;
                case 'unorderedlist':
                    dataField = []
                    for(let i=0;i<this.props.item.value.length;i++){
                       dataField.push(<li>{this.props.item.value[i]}</li>);
                       if(Boolean(this.props.item.spaceBtwPoints && i!=this.props.item.value.length-1))
                       { dataField.push(<br/>);} 
                    }
                    dataField = <ul style={this.props.item.style}>{dataField}</ul>
                    break;
                case 'orderedlist':
                    dataField = []
                    for(let i=0;i<this.props.item.value.length;i++){
                       dataField.push(<li>{this.props.item.value[i]}</li>); 
                       if(Boolean(this.props.item.spaceBtwPoints && i!=this.props.item.value.length-1))
                       { dataField.push(<br/>);}
                    }
                    dataField = <ol style={this.props.item.style}>{dataField}</ol>
                    break;
                case 'paragraph':
                    dataField = <p style={this.props.item.style} >{this.props.item.value}</p>
                    break;
                case 'bold':
                    dataField = <b style={this.props.item.style}>{this.props.item.value}</b>
                    break
                case 'span':
                    dataField = <span style={this.props.item.style} >{this.props.item.value}</span>
                    break;
                case 'break':
                    dataField = <br/>
                    break;
                case "divwithspan":
                    dataField = <div className={this.props.item.className} style={this.props.item.divStyle}><span style={this.props.item.spanStyle} >{this.props.item.value}</span></div>
                    break;
                case "none":
                    dataField = <div></div>
                    break;
                default:
                    console.log("Invalid field type");
            }

        return dataField;
    }
}

export default class DataField extends Component {

    render(){
        return <div>
        <GridRow {...this.props.item.gridRowProps}  style = {this.props.item.rowStyle}>
            <GridColumn {...this.props.item.gridColumnProps} style = {this.props.item.columnStyle}>
        {
            this.props.item.useLabel ?  
                <FieldLabel label={this.props.item.label_lang ? <Translate value={this.props.form+"."+ this.props.item.label_lang } /> : this.props.item.label} {...this.props.item.fieldLableProps}>
                    <Field name={this.props.item.name} 
                    i18nForm={this.props.form}
                    onChange={(e)=>{this.props.onChange(e,this.props.item)}} 
                    onBlur={(e)=>{this.props.onBlur(e,this.props.item)}}
                    onFocus={()=>{this.props.onFocus()}}
                    item={this.props.item} component={Item} />
                </FieldLabel>
            : <FieldLabel label=""  {...this.props.item.fieldLableProps}>
                <Field name={this.props.item.name} 
                i18nForm={this.props.form}
                onChange={(e)=>{this.props.onChange(e,this.props.item)}} 
                onBlur={(e)=>{this.props.onBlur(e,this.props.item)}}
                onFocus={()=>{this.props.onFocus()}}
                item={this.props.item} component={Item} />
            </FieldLabel>
        }
        </GridColumn>
        </GridRow>
    </div>
    }
}
